//
// DepotEvent.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../lib";
import "@sas-dvr/ltjs-commons/events/PortableEvent";
import "@sas-dvr/ltjs-commons/models/BaseModel";

var DepotEvent = createModule("transport::DepotEvent", ["commons::PortableEvent"], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getAssociatedModel: [1],
    },
    ,
    ,
]);
export default DepotEvent;
